import { Component, Input } from '@angular/core';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { AiAgentDashboardResponse } from '../../../models/responses/ai-agent-dashboard-response';
import { CallLogService } from '../../../services/call-log.service';
import { TitleAndData } from '../../../models/views/title-and-data';
import { NgFor, NgIf } from '@angular/common';
import { FormModuleTemplate } from '../../../module-templates/form-module-template';
import { FormControl } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { CallLogResponse } from '../../../models/responses/call-log-response';
import moment from 'moment-timezone';
import { getStandardDateFormat } from '../../../utilities/date-utils';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';

@Component({
  selector: 'app-ai-agent-dashboard',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    FormModuleTemplate
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './ai-agent-dashboard.component.html',
  styleUrl: './ai-agent-dashboard.component.scss'
})
export class AiAgentDashboardComponent {
  @Input() aiAgent!: AiAgentResponse;
  aiAgentDashboard: TitleAndData[] = [];
  isLoading: boolean = false;
  startDateRangePickerValue: FormControl = new FormControl();
  endDateRangePickerValue: FormControl = new FormControl();
  mostRecentCalls: {time: string, phone: string}[] = [];

  constructor(
    private callLogService: CallLogService,
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService,
  ) { }

  ngOnInit() {
    this.setDateRangeFilter();
    this.initDates();
    this.initCallLogs();
  }

  initDates() {
    const now = new Date();
    this.startDateRangePickerValue.setValue(new Date(now.getFullYear(), now.getMonth(), 1));
    this.endDateRangePickerValue.setValue(now);
  }

  initCallLogs() {
    this.isLoading = true;

    this.callLogService.fetchAiAgentDashboard(this.aiAgent.id, this.startDateRangePickerValue.value, this.endDateRangePickerValue.value).subscribe({
      next: (response) => {
        this.setMostRecentCalls();

        if (response) {
          this.aiAgentDashboard = this.mapCallLogServiceToTitleAndData(response);
        } else this.aiAgentDashboard = [];

        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        alert('Server error, contact support');
      }
    });
  }

  setMostRecentCalls() {
    this.mostRecentCalls = this.aiAgent.callLogs.filter(cl => {
      const d = moment(cl.startTime);
      const start = moment(this.startDateRangePickerValue.value);
      const end = moment(this.endDateRangePickerValue.value);

      return d.isBetween(start, end, null, '[]');
    }).map((cl) => {
      return {time: getStandardDateFormat(cl.startTime), phone: cl.callerPhoneNumber}
    });
  }

  onClearFilterClicked() {
    this.endDateRangePickerValue.reset();
    this.startDateRangePickerValue.reset();
  }

  setDateRangeFilter() {
    this.endDateRangePickerValue.valueChanges.subscribe(() => {
      if (this.endDateRangePickerValue.value && this.startDateRangePickerValue.value)
        this.initCallLogs();
    });
  }
  
  onViewAllClicked(){
    this.aiConfigurationPageEventsService.onTabToRenderEvent.emit(5);
  }

  mapCallLogServiceToTitleAndData(aiAgentDashboard: AiAgentDashboardResponse): TitleAndData[] {
    return [
      { title: 'Average call duration (min)', data: this.mapSecondToMinutes(aiAgentDashboard.callAverageDurationInSeconds) },
      { title: 'Amount of calls', data: aiAgentDashboard.amountOfCallsDone.toString() },
      { title: 'Minutes used', data: this.mapSecondToMinutes(aiAgentDashboard.amountOfSecondsUsed) },
    ];
  }

  mapSecondToMinutes(milliseconds: number) {
    const seconds = milliseconds / 1000;
    if (seconds % 60 != 0)
      return (seconds / 60).toFixed(2) + 'min';
    else
      return (seconds / 60).toString() + 'min';
  }
}
